import functions from "@/utils/functions";
import VueRouter from "vue-router";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import request from "@/utils/wlqrequest.js";
import Vue from "vue";
import Viser from "viser-vue";
import Antd from "ant-design-vue/es";
import Print from "vue-print-nb";
import htmlToPdf from "@/utils/htmlToPdf";
import 'ant-design-vue/dist/antd.css';
import { Card, List } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 的样式
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(Card);
Vue.use(List);
Vue.config.productionTip = false;
Vue.prototype.$functions = functions;
Vue.use(VueRouter);
Vue.use(Viser);
Vue.use(Antd);
Vue.use(Print);
Vue.use(htmlToPdf);
Vue.prototype.request=request
new Vue({
  router,
  store,
  render: (h) => h(App),

}).$mount("#app");
